import SimpleQuestion from "./SimpleQuestion";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import { getLanguageCode } from "../store/components";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useStylesLocally } from "../muithemeclasses";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import translations from "../utils/translations";
const MulitiSelect = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <MulitiSelectDropDown
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></MulitiSelectDropDown>
      }
    ></SimpleQuestion>
  );
};

const MulitiSelectDropDown = ({ node, handleAnswerChange, qfusermode }) => {
  const languagecode = useSelector(getLanguageCode);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const handleAnswer = (event, value) => {
    handleAnswerChange(value);
  };

  const classes = useStylesLocally();

  return (
    <Autocomplete
      multiple
      id={`MulitiSelect_${node.id}`}
      disabled={qfusermode === INSURER ? true : false}
      disableCloseOnSelect
      options={typeof node.logic === "string" ? [] : node.logic.options}
      getOptionLabel={(option) =>
        option.text[languagepreference]
          ? option.text[languagepreference]
          : option.text["en"]
      }
      classes={{
        root: classes.rootForMultiSelect,
        listbox: classes.listbox,
        input: classes.input,
        tag: classes.tag,
      }}
      onChange={handleAnswer}
      value={node.answer ? node.answer : []}
      renderInput={(params) => (
        <TextField
          {...params}
          classes={{
            root: classes.textFieldRootForMultiSelect,
          }}
          placeholder={translations[languagepreference].selectMultiple}
          fullWidth
          // onFocus={() => {
          //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
          //     helpTipPB.VerticalHelpOrTipFncs.changeText(
          //       this.props.questionHint
          //     );
          //   }
          // }}
          // onBlur={() => {
          //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
          //     helpTipPB.VerticalHelpOrTipFncs.changeText("");
          //   }
          // }}
        />
      )}
    />
  );
};

export default MulitiSelect;
